import { render, staticRenderFns } from "./ChangeRequestDetailView.vue?vue&type=template&id=1b79f0c9&"
import script from "./ChangeRequestDetailView.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports